import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { formTypeList } from '../../constants/form'
import { GET_ONE_BANNER } from '../../store/types'
import { getOneBanner } from '../../store/actions/bannerAction'
import BannerForm from './BannerForm'

const EditBanner = ({ id, setOpen }) => {
    const dispatch = useDispatch()
    const { banner } = useSelector((state) => state.banner)
    useEffect(() => {
        dispatch(getOneBanner(id))
        return () => {
            dispatch({
                type: GET_ONE_BANNER,
                payload: null,
            })
        }
    }, [dispatch, id])
    return banner ? (
        <BannerForm
            formType={formTypeList.EDIT}
            setOpen={setOpen}
            propsValue={banner}
        />
    ) : null
}

export default EditBanner
